import { Component, inject } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { DocumentsStore } from '../../stores/documents.store';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-documents-filter-no-results',
  imports: [Button, NgIcon, TranslocoPipe],
  templateUrl: './documents-filter-no-results.html',
})
export class DocumentsFilterNoResults {
  private documentsStore = inject(DocumentsStore);

  protected onClickReset() {
    this.documentsStore.reset();
  }
}
